export const PAGE_SCROLL_CONTAINER_ID = 'provider-portal-page-scroll'

export const scrollToPageTop = () => {
  document.getElementById(PAGE_SCROLL_CONTAINER_ID)?.scrollTo(0, 0)
  window.scrollTo(0, 0)
}
